import { z } from 'zod'

/**
 * The parts of a site's record whose history is kept. Mirrors
 * `SiteChangeEntity` in prisma/schema.prisma. See docs/site-visits.md.
 *
 * Findings (problems, recommended work) are not here: they belong to the
 * visit that found them and need no log to be dated.
 */
export const SITE_CHANGE_ENTITIES = [
  'BOUNDARY',
  'AREA',
  'TREE',
  'WATER_SOURCE',
  'TIMER',
  'ZONE',
  'EQUIPMENT',
] as const

export const siteChangeEntitySchema = z.enum(SITE_CHANGE_ENTITIES)

export type SiteChangeEntity = z.infer<typeof siteChangeEntitySchema>

/** What happened to it. Mirrors `SiteChangeAction`. */
export const SITE_CHANGE_ACTIONS = [
  'ADDED',
  'CHANGED',
  'REMOVED',
  'RESTORED',
] as const

export const siteChangeActionSchema = z.enum(SITE_CHANGE_ACTIONS)

export type SiteChangeAction = z.infer<typeof siteChangeActionSchema>

/**
 * Why something really came off the site. Mirrors `RemovalReason`.
 *
 * Archived with no reason is the other way off: recorded by mistake, which
 * hides it from past maps as well as the current one.
 */
export const REMOVAL_REASONS = ['REMOVED_BY_US', 'GONE'] as const

export const removalReasonSchema = z.enum(REMOVAL_REASONS)

export type RemovalReason = z.infer<typeof removalReasonSchema>
